export default __webpack_public_path__ + "static/media/Tierp.922760a5.png";